(async function () {
	if (window.TrustooThemeRatingWidgetsExecuted) {
		return;
	}
	window.TrustooThemeRatingWidgetsExecuted = true;

	let baseUrl = "https://rtestweb.sealapps.com/api/v1";

	const ratingNode = document.querySelector(
		"#seal-star-rating-widget>.product-icon-list"
	);
	if (ratingNode) {
		return;
	}
	let shopIdData = JSON.parse(
		document.querySelector("#seal_shop_id").textContent
	);
	let productId = JSON.parse(
		document.querySelector("#seal_product_id").textContent
	);
	let useMetaFields = false;

	let userSettings = {};
	let productRating = {};
	let ratingIconSvg = `<svg class="trustoo-rating-icon" width="24" height="24" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#FFA800" d="M7.09194 1.53428C7.44936 0.759408 8.55064 0.759406 8.90806 1.53428L10.3048 4.56237C10.4504 4.87817 10.7497 5.09562 11.0951 5.13657L14.4066 5.5292C15.254 5.62967 15.5943 6.67706 14.9678 7.25642L12.5195 9.52052C12.2642 9.75665 12.1499 10.1085 12.2177 10.4496L12.8675 13.7203C13.0339 14.5573 12.1429 15.2046 11.3983 14.7878L8.48844 13.159C8.18497 12.9892 7.81503 12.9891 7.51156 13.159L4.60172 14.7878C3.85711 15.2046 2.96615 14.5573 3.13245 13.7203L3.78235 10.4496C3.85012 10.1085 3.73581 9.75665 3.48047 9.52052L1.0322 7.25643C0.4057 6.67706 0.746015 5.62967 1.59341 5.5292L4.9049 5.13657C5.25027 5.09562 5.54955 4.87817 5.69522 4.56237L7.09194 1.53428Z"></path></svg>`;
	let reqErr = null;
	let shopId = "";
	if (Shopify.designMode) {
		shopId = shopIdData;
	} else {
		if (shopIdData !== null) {
			shopId = shopIdData;
		} else {
			shopId = ShopifyAnalytics.lib.config.Trekkie.defaultAttributes.shopId;
		}
	}

	let isProRatingUpdate = false;
	let isSettingUpdate = false;
	let statusData = null;

	const settingsInfo = {
		star_color: "#FFA800",
		nostar_color: "#E6E6E6",
		rating_icon_type: 1,
		is_show_stars_without_review: 1,
		auto_switch_language: 2,
		language: "en",
		is_show_review_number: 1,
	};
	let ratingInfo = null,
		langInfo = null;

	let acquiredSettings = null;
	if (typeof vstar_review_settings !== "undefined") {
		acquiredSettings = vstar_review_settings;
	} else {
		const data = await getUserSettings(shopId);
		acquiredSettings = data;
	}

	if (acquiredSettings) {
		Object.keys(settingsInfo).forEach(key => {
			if (acquiredSettings[key]) {
				settingsInfo[key] = acquiredSettings[key];
			}
		});
	}

	if (typeof vstar_product_rating !== "undefined") {
		ratingInfo = vstar_product_rating;
	} else {
		ratingInfo = await getProductRating(productId, shopId);
	}

	let lang = "";
	if (settingsInfo.auto_switch_language === 1) {
		lang = Shopify.locale;
	} else {
		lang = settingsInfo.language;
	}

	if (
		settingsInfo.is_show_stars_without_review === 2 &&
		ratingInfo.rating == 0
	) {
		return;
	}
	const normalIcon = `<svg class="trustoo-rating-icon" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M10 0L12.8214 6.11672L19.5106 6.90983L14.5651 11.4833L15.8779 18.0902L10 14.8L4.12215 18.0902L5.43493 11.4833L0.489435 6.90983L7.17863 6.11672L10 0Z"/>
	</svg>
	`;

	const ratingIconType = settingsInfo.rating_icon_type || 1;
	const iconString = gsSession("get", "ttRatingIcons");
	let sessionIcons = {};
	if (iconString) {
		sessionIcons = JSON.parse(iconString);
		ratingIconSvg = sessionIcons["star" + ratingIconType];
	}

	if (typeof vstar_custom_info !== "undefined") {
		if (vstar_custom_info.custom_style_info) {
			let cssCode = "";
			const pageTypeNode = document.getElementById("tt-rating-page-type");
			const pageType = pageTypeNode.textContent;
			const themeId =
				typeof Shopify !== "undefined" && Shopify.theme && Shopify.theme.id;
			vstar_custom_info.custom_style_info.list.forEach(it => {
				if (
					it.type === "rating" &&
					(it.target_page === "all" || it.target_page === pageType) &&
					(!it.theme_id || themeId === it.theme_id)
				) {
					cssCode += it.css_style_code;
				}
			});
			if (cssCode) {
				document.head.insertAdjacentHTML(
					"beforeend",
					`<style id="tt-swiper-style">${cssCode}</style>`
				);
			}
		}
	}

	if (!ratingIconSvg) {
		if (ratingIconType === 1) {
			ratingIconSvg = normalIcon;
		} else {
			fetch(`https://cdn.vstar.app/static/customer/icons.json`)
				.then(response => {
					if (!response.ok) {
						ratingIconSvg = normalIcon;
						throw new Error("Network response was not ok");
					}
					return response.text();
				})
				.then(iconString => {
					const ratingIconName = getRatingIconName(ratingIconType);
					const icons = JSON.parse(iconString);
					ratingIconSvg = icons[ratingIconName];
					sessionIcons["star" + ratingIconType] = ratingIconSvg;
					gsSession("set", "ttRatingIcons", JSON.stringify(sessionIcons));
				})
				.catch(error => {
					ratingIconSvg = normalIcon;
				})
				.finally(() => {
					document
						.querySelectorAll(
							".vstar-star>.star-item:not(.half-star),.vstar-star>.star-item.half-star>div"
						)
						.forEach(it => (it.innerHTML = ratingIconSvg));
				});
		}
	}

	if (typeof vstar_lang_json !== "undefined") {
		langInfo = vstar_lang_json;
		setRatingText();
	} else {
		getLangWords(shopId).then(res => {
			langInfo = JSON.parse(res.lang_json);
			setRatingText();
		});
	}

	function getStar(size = 14, color = "") {
		return `<svg  style="width:${size}px;height:${size}px"
    viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.389 11.29a.964.964 0 0 0-.255.827l.783 4.807c.062.381 0 .654-.296.882a.926.926 0 0 1-1.017.077l-4.191-2.377a.848.848 0 0 0-.826 0l-4.015 2.377a.926.926 0 0 1-1.017-.077c-.297-.228-.534-.5-.472-.882l.96-4.907a.964.964 0 0 0-.255-.826L.292 8.297a1.052 1.052 0 0 1-.245-1.04.981.981 0 0 1 .78-.692l4.547-.84a.891.891 0 0 0 .667-.51L8.135.566A.96.96 0 0 1 9 0c.368 0 .703.22.866.566l2.011 4.649c.13.275.38.466.668.51l4.63.84a.98.98 0 0 1 .778.691c.113.368.018.772-.245 1.041l-3.32 2.994z"
    fill="${color}" fill-rule="evenodd"/></svg>`;
	}

	function params2Url(obj) {
		let aUrl = [];
		let fnAdd = function (key, value) {
			return key + "=" + value;
		};
		for (var k in obj) {
			aUrl.push(fnAdd(k, obj[k]));
		}
		return aUrl.join("&");
	}

	async function httpRequest(api, method, params, data, opts) {
		let url = `${baseUrl}/${api}`;
		let fetchOptions = {
			method: method,
			headers: {
				"Content-Type": "application/json",
			},
		};
		if (opts != undefined) {
			fetchOptions = Object.assign(opts, fetchOptions);
		}
		if (method.toUpperCase() == "GET") {
			url += "?" + params2Url(params);
		} else if (method.toUpperCase() == "POST") {
			fetchOptions = {
				body: JSON.stringify(data),
			};
		}
		await fetch(url, fetchOptions)
			.then(response => {
				return response.text();
			})
			.then(responseText => {
				result = JSON.parse(responseText);
			})
			.then(error => {});

		return result;
	}

	async function getUserSettings(shopId) {
		if (JSON.stringify(userSettings) == "{}") {
			let params = {
				shop_id: shopId,
			};
			let res = await httpRequest("users/get_reviews_settings", "GET", params);
			userSettings = res.data;
		}
		return userSettings;
	}

	async function getInstallStatus() {
		let url = "reviews/get_shop_install_status";
		let params = {
			shop_id: shopId,
			product_id: productId,
		};
		const res = await httpRequest(url, "GET", params);
		return res;
	}

	async function getProductRating(productId, shopId) {
		if (JSON.stringify(productRating) == "{}") {
			let params = {
				shop_id: shopId,
				product_id: productId,
			};
			let res = await httpRequest("reviews/get_product_rating", "GET", params);
			productRating = res.data;
		}
		return productRating;
	}

	async function getLangWords() {
		const url = "reviews/get_customer_self_define_lang";
		const params = {
			shop_id: shopId,
			lang,
		};
		let res = await httpRequest(url, "GET", params);
		return res.data;
	}

	function generateStarRating() {
		var sealStarRatingWidgetDom = Array.from(
			document.querySelectorAll("#seal-star-rating-widget")
		).find(it => !it.dataset.filled);
		sealStarRatingWidgetDom.classList.add("vstar-star");
		var size = sealStarRatingWidgetDom.getAttribute("data-star-size");
		var shtml = "";

		shtml = `
		<div class="product-icon-list vstar-star" style="--star-color:${settingsInfo.star_color};--nostar-color:${settingsInfo.nostar_color};--star-size:${size}px"></div>`;
		sealStarRatingWidgetDom.innerHTML = shtml;
	}
	function setRatingText() {
		var ratingWidgetNode = Array.from(
			document.querySelectorAll("#seal-star-rating-widget")
		).find(it => !it.dataset.filled);
		var size = ratingWidgetNode.getAttribute("data-star-size");
		let rating = parseFloat(ratingInfo.rating).toFixed(1);
		if (!parseInt(rating)) rating = 0;
		const number =
			settingsInfo.is_show_review_number === 1 ? ratingInfo.total_reviews : "";
		let content = langInfo.product_pages_reviews
			.replace(/{{review_number}}/g, number)
			.replace(/{{review_rating}}/g, rating)
			.trim();

		const starInx = content.indexOf("{{star}}");
		let preStarHtml = "",
			nextStarHtml = "",
			starHtml = "";
		if (starInx !== -1) {
			if (starInx !== 0) {
				preStarHtml = `<div class="tt-rating-text">${content.slice(
					0,
					starInx
				)}</div>`;
			}
			nextStarHtml = `<div class="tt-rating-text">${content.slice(
				starInx + 8
			)}</div>`;
			starHtml = getStarString(rating, size);
		} else {
			nextStarHtml = `<div class="tt-rating-text">${content}</div>`;
		}
		document.querySelectorAll("#seal-star-rating-widget").forEach(item => {
			item.innerHTML = `<div class="product-icon-list vstar-star" style="--star-color:${
				settingsInfo.star_color
			};--nostar-color:${settingsInfo.nostar_color};--star-size:${size}px">${
				preStarHtml + starHtml + nextStarHtml
			}</div>`;
			item.onclick = function () {
				const node = document.querySelector(
					"#vstar-reviews,#seal-review-widget,#noreviews-wrapper"
				);
				if (node) {
					scrollTo(node);
				}
			};
		});
		const onTTDetailRatingEmbed = new CustomEvent("onTTDetailRatingEmbed", {
			detail: {},
			bubbles: true,
			cancelable: true,
		});
		document.dispatchEvent(onTTDetailRatingEmbed);
	}

	function getStarString(rating, size) {
		let starNum = Math.floor(rating);
		let starTag = "";
		const star = ratingIconSvg;
		const starString = `<div class="star-item">${star}</div>`;
		const nostarString = `<div class="star-item nostar">${star}</div>`;
		for (let i = 0; i < starNum; i++) {
			starTag += starString;
		}
		if (starNum < rating) {
			const percentage = ((rating - starNum) * 100).toFixed(2);
			starNum++;
			starTag += `<div class="star-item half-star">
			<div class="item-nostar">${star}</div>
			<div class="item-star" style="width:${iconShowRatioAdjustment(percentage)}%">
				${star}
			</div>
		</div> `;
		}

		for (let i = 0; i < 5 - starNum; i++) {
			starTag += nostarString;
		}
		return starTag;
	}

	function iconShowRatioAdjustment(percentage) {
		let temp = parseInt(percentage) / 100;
		const ratio = temp;
		switch (settingsInfo.rating_icon_type) {
			case 13: {
				temp = 0.28 + parseFloat((0.44 * ratio).toFixed(2));
				break;
			}
			case 15: {
				temp = 0.215 + parseFloat((0.57 * ratio).toFixed(2));
				break;
			}
		}
		temp = temp * 100;
		return temp;
	}
	function scrollTo(node) {
		node.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});
	}
	function getRatingIconName(type) {
		const codes = [
			"star",
			"rounded",
			"spikes",
			"surrounded",
			"fire",
			"heart",
			"diamond",
			"crown",
			"trophy",
			"shirt",
			"skirt",
			"bag",
			"tie",
			"cup",
			"leaf",
			"seedling",
			"footprint",
			"chef",
		];
		return codes[type - 1];
	}
	function gsSession(method, name, data) {
		if (method === "set") {
			try {
				sessionStorage.setItem(name, JSON.stringify(data));
			} catch (error) {}
		} else {
			return JSON.parse(sessionStorage.getItem(name));
		}
	}
})();
